@if (type() === buildingType.Catalog || type() === buildingType.SpaceConfig) {
    <svg:path
    class="single-roof"
    [attr.d]="innerRoofPath()" />
} @else {
    <!-- Roof Border -->
    <svg:path
        class="outer-roof"
        [attr.d]="outerRoofPath()" />

    <!-- Roof -->
    <svg:path
        [attr.d]="innerRoofPath()"
        [attr.fill]="'var(--roof-bg)'" />
}

    
    